import React, { useEffect, useState } from 'react';
import AppNavbar from '../../../components/Navbar'
import { Form, Button, Container, Card, Row, Col, Spinner } from 'react-bootstrap'
import './login.css'
import { Link } from 'react-router-dom'
import google from '../../../images/google.svg'
import eye from '../../../images/eye.svg'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth';
import {getAuth, setPersistence,browserLocalPersistence, signInWithEmailAndPassword} from 'firebase/auth'
import Profile from '../../profile/profile'
import {FaEye, FaEyeSlash} from 'react-icons/fa'
import { useNavigate } from 'react-router-dom';


const firebaseConfig = {
    apiKey: "AIzaSyBKWdYhj6i6NcBAiXmhAktyI_bAMwAJuOo",
    authDomain: "tripz-travel-bot.firebaseapp.com",
    projectId: "tripz-travel-bot",
    storageBucket: "tripz-travel-bot.appspot.com",
    messagingSenderId: "720844828187",
    appId: "1:720844828187:web:00adcaa6e56ca989d0d2be",
    measurementId: "G-5BCYRZXXNW"
  };
  
  firebase.initializeApp(firebaseConfig)

const Login = ({setUserData}) => {
  const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  // const [userData, setUserData] = useState({ name: '', email: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate()
  


    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            setUser(user);
          } else {
            setUser(null);
          }
        });
      }, []);

      // const handleSignIn = () => {
    
      //   const provider = new firebase.auth.GoogleAuthProvider();
      //   firebase
      //     .auth()
      //     .signInWithPopup(provider)
      //     .then((result) => {
      //       // Successful sign-in with Google
      //       const { displayName, email} = result.user;
      //   const retrievedUserData = {
      //     name: displayName,
      //     email: email,
        
      //   };
      //   setUserData(retrievedUserData);
      //       setUser(result.user);
      //       navigate('/profile')
      //     })
      //     .catch((error) => {
      //       // Handle sign-in errors
      //       console.error('Google sign-in error:', error);
      //     });
          
      // };
      const provider = new firebase.auth.GoogleAuthProvider();
      const handleSignIn = () => {
       
        firebase
          .auth()
          .signInWithRedirect(provider)
          .catch((error) => {
            // Handle sign-in errors
            console.error('Google sign-in error:', error);
          });
      };
const handleRedirectResult = (result) => {
  if (result.user) {
    // Successful sign-in with Google
    const { displayName, email } = result.user;
    const retrievedUserData = {
      name: displayName,
      email: email,
    };
    setUserData(retrievedUserData);
    setUser(result.user);
    navigate('/profile');
  } else {
    setLoading(false); // If no user, set loading to false to render the login component
  }
};

useEffect(() => {
  firebase
    .auth()
    .getRedirectResult()
    .then(handleRedirectResult)
    .catch((error) => {
      // Handle sign-in errors
      console.error('Google sign-in error:', error);
      setLoading(false); // Set loading to false in case of an error
    });
}, []);


      // useEffect(() => {
      //   firebase
      //     .auth()
      //     .getRedirectResult()
      //     .then((result) => {
      //       if (result.user) {
      //         // Successful sign-in with Google
      //         const { displayName, email } = result.user;
      //         const retrievedUserData = {
      //           name: displayName,
      //           email: email,
      //         };
      //         setUserData(retrievedUserData);
      //         setUser(result.user);
      //         navigate('/profile');
      //       } else {
      //         setLoading(false); // If no user, set loading to false to render the login component
      //       }   })
      //       .catch((error) => {
      //         // Handle sign-in errors
      //         console.error('Google sign-in error:', error);
      //         setLoading(false); // Set loading to false in case of an error
      //       });
      //   }, []);


      const handleEmailSignIn = (e) => {
        e.preventDefault();
      
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then((result) => {
            const user = result.user;
      
            if (user.displayName && user.email) {
              // User profile information is already available
              setUserData({
                name: user.displayName,
                email: user.email,
              });
              setUser(user);
              navigate('/profile');
            } else {
              // Retrieve user profile information from Firebase
              user
                .getIdTokenResult()
                .then((idTokenResult) => {
                  const { name, email} = idTokenResult.claims;
                  setUserData({
                    name,
                    email
                    
                  });
                  setUser(user);
                  navigate('/profile');
                })
                .catch((error) => {
                  console.error('Error retrieving user profile information:', error);
                });
            }
          })
          .catch((error) => {
            const errorCode = error.code;
        let errorMessage = '';

        switch (errorCode) {
          case 'auth/invalid-email':
            errorMessage = 'Invalid email format.';
            break;
          case 'auth/user-not-found':
            errorMessage = 'User not found. Please check your email.';
            break;
          case 'auth/wrong-password':
            errorMessage = 'Invalid password. Please try again.';
            break;
          default:
            errorMessage = 'An error occurred. Please try again later.';
        }

        setErrorMessage(errorMessage); // Set the error message in the state
      });
      };
      
    
      const handleLogout = () => {
        firebase
          .auth()
          .signOut()
          .then(() => {
            // Successful logout
            setUser(null);
            setUserData({ name: '', email: '' });
          })
          .catch((error) => {
            // Handle logout errors
            console.error('Logout error:', error);
          });
      };
    
      // if (user) {
      //   return <Profile user={user} userData={userData}handleLogout={handleLogout} />;
      // }
    
      const handleEmailChange = (e) => {
        setEmail(e.target.value);
      };
    
      const handlePasswordChange = (e) => {
        setPassword(e.target.value);
      };

      const togglePasswordVisibility = (e) => {
        e.preventDefault()
        setShowPassword(!showPassword);
      };
    
  return (
    <div>
     <AppNavbar/>
     <div>
      {loading ? (  <div>
     
     <div className='justify-content-center align-items-center text-center my-5 py-5'>
     <Spinner animation="border" role="status">
           <span className="visually-hidden">Loading...</span>
         </Spinner>
         </div>
       
      </div>): (
 <Container fluid style={{background:'#F9F9F9'}} className='justify-content-center align-items-center text-align-center p-3 p-md-5'>
        
 <Card style={{background:'#fff', maxWidth:'45rem'}} className='p-3 p-md-5 m-auto my-4 border-0 '>
     <h3 className='text-center welcome'>Welcome Back!</h3>
     <Form className='p-2 p-md-5 py-3 '>
     <Form.Group className="mb-4" controlId="formBasicEmail">
 <Form.Label className='login-form-label'>Email address</Form.Label>
 <Form.Control type="email" placeholder="Enter email address" className='py-2' value={email} onChange={handleEmailChange}/>
 
</Form.Group>

<Form.Group className="mb-3" controlId="formBasicPassword">
 <Form.Label className='login-form-label'>Password</Form.Label>
 <div className='input-box'>
 <button onClick={togglePasswordVisibility} className='eye border-0' style={{background:"#fff"}}>
{showPassword ? <FaEyeSlash /> : <FaEye />}
</button>
 <Form.Control   type={showPassword ? 'text' : 'password'} placeholder="Password" className='py-2' value={password} onChange={handlePasswordChange}/>
 </div>
 <Form.Text className="text-danger my-2">{errorMessage}</Form.Text>
</Form.Group>

<Form.Group className="mb-3 align-items-center d-flex justify-content-between" controlId="formBasicCheckbox">
 <Form.Check type="checkbox" label="Keep me signed in" />
 <Link to="/forgot-password" className='forgot-password'>Forgot Password</Link>
</Form.Group>
<div className=' text-center mt-5'>
<Button type="submit"  onClick={handleEmailSignIn}className='border-0 login-btn' >
 Log In
</Button>
</div>
 </Form>
 <div className='text-center mt-3'>
 <h5 className='account'>Don't have an account?  <span><Link to='/signup' className='forgot-password'>Sign up</Link></span></h5>

 </div>
 </Card>
 <div className=' justify-content-center align-items-center mt-5'>
     <div className='d-flex flex-row justify-content-center gap-3 align-items-center'>
         <div className='line'></div>
         <p className='line-p'>or</p>
         <div className='line'></div>
     </div>
     <div className='align-items-center justify-content-center text-center mt-4'>
         <Button onClick={handleSignIn}className='google-login border-0 '> <img src= {google} alt='google'/> &nbsp; &nbsp;Log in with Google</Button>
     </div>
 </div>

</Container>
      )}
     </div>
    
    </div>
  )
}

export default Login
